// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10YbA","type":"styles_type__dkRpQ","choices":"styles_choices__1PV7L"};